/**************************************************
 * Nombre:       Landing_Reunion_Grupal
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Portada_RG from "./Apartados/LandingRG/Portada_RG";
import LineaAnimada from "../Componentes/LineaAnimada";
import {obtenerArrLimitador} from "../Utilidades/obtenerArrLimitador";
import Fechas_RG from "./Apartados/LandingRG/Fechas_RG";
import Temas_RG from "./Apartados/LandingRG/Temas_RG";
import Motivacion_RG from "./Apartados/LandingRG/Motivacion_RG";
import TextoMovimiento from "../Componentes/TextoMovimiento";
import Preguntas_RG from "./Apartados/LandingRG/Preguntas_RG";
import Footer from "../Footer";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {contarWheres} from "../../Servicios/BD/Contadores/contarWheres";
import {where} from "firebase/firestore";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";

const Landing_Reunion_Grupal = ({item}) => {
    const {sCell} = useResponsive()
    const [cupos, setCupos] = useState(0)


    const obtenerCupos = async (id) => {

        let w = [where('idLanding', '==', id), where('estado', '!=', 'Archivado')]
        let doxCuposReales = await contarWheres({coleccion: 'leads', wheres: w})
        let doxCuposBot = await obtenerDoc('datosBot', id)

        let numCupos = 0
        if (doxCuposReales.data) {
            numCupos = parseInt(doxCuposReales.data)
        }

        if (doxCuposBot.data) {
            numCupos += parseInt(doxCuposBot.data)
        }

        setCupos(numCupos)

    }

    useEffect(() => {

        if (item.id) {
            obtenerCupos(item.id)
        }

    }, [item]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Portada_RG item={item}  />
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{position: 'absolute', top: 150, zIndex: 1}}
            >
                <TextoMovimiento item={item}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? 0 : 10}}>
                <LineaAnimada lista={obtenerArrLimitador(item, cupos)} />
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? 6 : 8}}>
                <Fechas_RG item={item} cupos={cupos}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 8}}>
                <Temas_RG item={item}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 10, zIndex: 2}}>
                <Motivacion_RG item={item}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 12, zIndex: 2}}>
                <Fechas_RG item={item} cupos={cupos}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{zIndex: 1, mt: -70}}
            >
                <TextoMovimiento item={item}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 4, zIndex: 2}}>
                <Preguntas_RG item={item}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 14}}>
                <Footer item={item}/>
            </Grid>


        </Grid>
    )

}
export default Landing_Reunion_Grupal